import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PersonalManager } from '@my-account/const';
import { IconModule } from '@spartacus/storefront';

@Component({
  selector: 'sd-personal-manager-template',
  templateUrl: './personal-manager-template.component.html',
  styleUrls: ['./personal-manager-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, IconModule],
})
export class PersonalManagerTemplateComponent {
  @Input() manager: PersonalManager;

  constructor() {}
}
